export default "__VITE_ASSET__Dm9p5WSZ__"